import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { svgToPng } from "../lib/exportPng";

const SITE = "https://sportsshields.ie";
export const WaIcon = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2Zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-1 2.2 5.2 5.2 0 0 0 1.1 2.8 11.9 11.9 0 0 0 4.6 4c1.7.7 2.4.8 3.2.7.5-.1 1.5-.6 1.8-1.2.2-.6.2-1.1.1-1.2l-.5-.2Z" /></svg>
);

export const shareMessage = (name) => `${name ? `Look at ${name}'s` : "Look at this"} personalised player shield! 🏆 Photo, name, club colours and stats, from €16. Design one for your child 👉 ${SITE}`;

export async function shareToWhatsApp(svg, name) {
  const text = shareMessage(name);
  try {
    if (svg && navigator.canShare) {
      const file = new File([await svgToPng(svg)], `${(name || "player").replace(/[^a-z0-9]+/gi, "-")}-shield.png`, { type: "image/png" });
      if (navigator.canShare({ files: [file] })) return await navigator.share({ files: [file], text });
    }
  } catch (e) {
    if (e?.name === "AbortError") return;
  }
  const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
  if (!window.open(url, "_blank", "noopener")) window.location.href = url;
}

export const WhatsAppShareButton = ({ getSvg, name, className = "", label = "Share on WhatsApp", testId = "whatsapp-share-button" }) => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await shareToWhatsApp(getSvg?.(), name); } catch { toast.error("Couldn't open sharing – please try again."); } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={go} disabled={busy} data-testid={testId}
      className={`flex items-center justify-center gap-2 bg-[#25D366] font-bold text-slate-900 transition-colors hover:bg-[#1fbe5b] disabled:opacity-60 ${className}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <WaIcon />} <span>{label}</span>
    </button>
  );
};
